import { LoadingState } from "../LoadingState";
import { ImageCard } from "../ImageCard";
import type { GeneratedImage } from "../types";

type ImagePreviewProps = {
  generatedImages: GeneratedImage[];
  isGenerating: boolean;
  selectedOrientation: string;
  onSelectImage: (imageUrl: string) => void;
  onStartEditing: (index: number) => void;
  selectingImageUrl: string | null;
  isMobile: boolean;
};

export const ImagePreview = ({
  generatedImages,
  isGenerating,
  selectedOrientation,
  onSelectImage,
  onStartEditing,
  selectingImageUrl,
  isMobile
}: ImagePreviewProps) => {
  if (generatedImages.length === 0 && !isGenerating) {
    return <LoadingState type="empty" isMobile={isMobile} />;
  }

  if (isGenerating) {
    return <LoadingState type="generating" isMobile={isMobile} />;
  }

  return (
    <div className={`grid ${isMobile ? "grid-cols-1 gap-4" : "grid-cols-3 gap-6"}`}>
      {generatedImages.map((img, index) => (
        <ImageCard
          key={img.url}
          image={img}
          index={index}
          selectedOrientation={selectedOrientation}
          onSelectImage={onSelectImage}
          onStartEditing={onStartEditing}
          selectingImageUrl={selectingImageUrl}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
};
